"use client";

import type { ProblemAnswerSlots } from "@workspace/gamja-platform/components/problem-answer-slots";

import ProblemHistoryComponent from "@/components/ProblemHistory";
import AdSenseInterstitial from "@/components/AdSenseInterstitial";
import AlgoliaRecommendations from "@/components/AlgoliaRecommendations";

/**
 * 공용 ProblemAnswer 에 주입하는 JCG UI 조각.
 *
 * 회차 이력 패널(PreviousSessionDialog 포함), 정답 공개 광고, 추천 문제는
 * JCG 상품·백엔드에 묶여 있어 공용 패키지가 소유하지 않는다.
 * 모듈 상수라 렌더마다 새로 만들지 않는다.
 */
export const jcgProblemAnswerSlots: ProblemAnswerSlots = {
  renderHistoryPanel: (props) => (
    <ProblemHistoryComponent
      isSignedIn={props.isSignedIn}
      user={props.user}
      id={props.id}
      isLoadingHistory={props.isLoadingHistory}
      problemHistory={props.problemHistory}
      isCorrectAnswerVisible={props.isCorrectAnswerVisible}
      isCorrect={props.isCorrect}
      hasPremiumAccess={props.hasPremiumAccess}
      problemTypes={props.problemTypes}
      premium={props.premium}
      variationNote={props.variationNote}
      showCurrentFeedback={props.showCurrentFeedback}
    />
  ),
  renderSolutionAd: ({ open, onClose }) => (
    <AdSenseInterstitial open={open} onClose={onClose} />
  ),
  renderRecommendations: ({ problemId }) => (
    <AlgoliaRecommendations
      target="problems"
      objectID={problemId}
      title="추천 문제"
      className="mx-0 mt-0"
      hideWhenEmpty={false}
      emptyMessage="추천할 문제가 아직 없습니다."
    />
  ),
};

// 광고 슬롯 자체를 생략해야 정답 공개가 광고 닫기 이벤트를 기다리지 않는다.
export const jcgAdFreeProblemAnswerSlots: ProblemAnswerSlots = {
  ...jcgProblemAnswerSlots,
  renderSolutionAd: undefined,
};
